import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import './multumim.css'
import rewardSmsImage from '../assets/rewards/reward_sms.jpg'

const Multumim = (props) => {
  const [firstName, setFirstName] = useState('');
  const location = useLocation();

  useEffect(() => {
    // Get the first name from URL parameters
    const searchParams = new URLSearchParams(location.search);
    const name = searchParams.get('nume') || '';
    setFirstName(name);
  }, [location]);

  return (
    <div className="multumim-container1">
      <Helmet>
        <title>Multumim - @Romania</title>
        <meta property="og:title" content="Multumim - @Romania" />
      </Helmet>
      <img
        alt="background"
        src="/external/map.svg"
        className="multumim-map"
      />
      <img
        alt="image"
        sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
        src="/external/compressed-7100w-5500w.gif"
        srcSet="/external//compressed-7100w-5500w.gif 1200w, /external/compressed-7100w-tablet.gif 800w, /external/compressed-7100w-mobile.gif 480w"
        className="multumim-gif"
      />
      <div className="multumim-container2">
        <div id="section-thanks" className="multumim-thanks form230-section">
          <div className="multumim-heading1">
            <h1 className="multumim-text1">🙏</h1>
            <h1 className="multumim-text2">
              Îți mulțumim că ți-ai făcut timp!
            </h1>
            <span className="multumim-text3">
              3.5% din impozitul tău pe venit va fi redirecționat către
              proiectele @Romania
            </span>
            <h3 className="multumim-text3-sub">
              Ești înscris în tragerea la sorți pentru vacanța la Anna Charisma Chalet
            </h3>
          </div>
          
          <div className="multumim-container3">
            <div className="multumim-heading2">
              <h1 className="multumim-text4">
                Câștigă o Vacanță Garantat!✨
              </h1>
              <span className="multumim-text5">
                Cum? E simplu: Înscrie-te în aplicația noastră și convinge prieteni, familie sau pe oricine din orașului
                tău să completeze Formularul 230 pentru @Romania
              </span>
            </div>
            <div className="multumim-container4">
              <a
                href={process.env.REACT_APP_AUTH_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="multumim-button button_blue"
              >
                <span>Înscrie-te aici 🚀</span>
              </a>
            </div>
          </div>
          
          {/* SMS Donation Container */}
          <div className="multumim-sms-donation">
            <div className="multumim-sms-content">
              <div className="multumim-sms-text">
                <h1 className="multumim-sms-header">
                  {firstName ? (
                    <><span className="multumim-highlight">{firstName}</span>, trimite SMS și poți câștiga o vacanță în fiecare lună!💬</>
                  ) : (
                    <>trimite SMS și poți câștiga o vacanță în fiecare lună!✨</>
                  )}</h1>
                <p className="multumim-sms-description">
                  Fiecare SMS <span className="multumim-highlight">reprezintă un pas înainte</span> către a arăta lumii frumusețea țării noastre.
                </p>
                <div className="multumim-sms-instructions">
                  <div className="multumim-sms-step">
                    <span className="multumim-step-number">1</span>
                    <span className="multumim-step-text">Trimite un SMS cu textul <strong>ROMANIA</strong></span>
                  </div>
                  <div className="multumim-sms-step">
                    <span className="multumim-step-number">2</span>
                    <span className="multumim-step-text">La numărul <strong>8864</strong></span>
                  </div>
                  <div className="multumim-sms-step">
                    <span className="multumim-step-number">3</span>
                    <span className="multumim-step-text">Donezi <strong>4€</strong> pentru promovarea României</span>
                  </div>
                  <div className="multumim-sms-step">
                    <span className="multumim-step-number">4</span>
                    <span className="multumim-step-text">Ești înscris în tombola lunară de vacanțe!</span>
                  </div>
                </div>
              </div>
              <div className="multumim-sms-visual">
                <div className="multumim-sms-phone">
                  <div className="multumim-phone-screen">
                    <div className="multumim-phone-header">
                      <span className="multumim-phone-cta">TRIMITE SMS</span>
                    </div>
                    <div className="multumim-message-bubble">
                      <span className="multumim-message-text">ROMANIA</span>
                      <span className="multumim-message-number">→ 8864</span>
                    </div>
                    <div className="multumim-phone-response">
                      <span>Mulțumim! Tocmai ai contribuit la promovarea României. ❤️🇷🇴</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="multumim-sms-tagline">
              <span>Cu ajutorul tău, <span className="multumim-highlight">punem România</span> înapoi pe harta lumii.🌍</span>
            </div>
            <div className="multumim-sms-see-prizes">
              <Link
                to="/#premii"
                className="multumim-button-secondary"
              >
                <span>Vezi premiile 🏆</span>
              </Link>
            </div>
          </div>
          
          {/* SMS Reward Card */}
          <div className="multumim-rewards-section">
            <div className="multumim-rewards-label">
              <span>Premiul din luna mai</span>
            </div>
            
            <div className="multumim-rewards-card-container">
              <a href="https://www.luxgardenhotel.com/" target="_blank" rel="noopener noreferrer" className="multumim-reward-card-link">
                <div className="multumim-reward-card">
                  <div className="multumim-reward-image-container">
                    <img
                      src={rewardSmsImage}
                      alt="LuxGarden Hotel Azuga"
                      className="multumim-reward-image"
                    />
                    <div className="multumim-reward-overlay">
                      <span className="multumim-reward-pill pill-purple">tombolă</span>
                      <span className="multumim-reward-pill pill-blue">SMS</span>
                    </div>
                  </div>
                  <div className="multumim-reward-content">
                    <div className="multumim-reward-main">
                      <div className="multumim-reward-location">
                        <span className="multumim-reward-icon">📍</span>
                        <span>Azuga, Prahova</span>
                      </div>
                      <h3 className="multumim-reward-title">Lux Garden Hotel</h3>
                      <ul className="multumim-reward-features">
                        <li className="multumim-reward-feature-pills">
                          <span className="multumim-reward-feature-pill pill-people">2 persoane</span>
                          <span className="multumim-reward-feature-pill pill-nights">3 nopți</span>
                        </li>
                        <li>Oază de 5 stele la poalele Bucegilor</li>
                        <li>SPA premium: piscină interioară și saune luxoase</li>
                        <li>Fitness high‑end și terapii revitalizante</li>
                        <li>Restaurant gourmet cu panoramă montană</li>
                        <li>Terasa cu vedere spre Munții Bucegi</li>
                        <li>Suite cu espresso bar și smart entertainment</li>
                        <li>Circuit MTB și drumeții în pădurile Azugăi</li>
                      </ul>
                    </div>
                    <div className="multumim-reward-info">
                      <div className="multumim-reward-info-header">
                        <span className="multumim-reward-info-icon">🎁</span>
                        <span>Prin SMS, câștigi lunar</span>
                      </div>
                      <p className="multumim-reward-info-text">                    
                        În fiecare lună, un donator prin SMS este extras aleatoriu pentru a câștiga un sejur la unul dintre hotelurile noastre partenere. Premiul pentru luna aceasta: 3 nopți la Lux Garden Hotel Azuga.
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Multumim
